var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", { staticClass: "noStyle" }),
    _vm._v(" "),
    _c("td", { staticClass: "options", attrs: { colspan: "8" } }, [
      _c(
        "div",
        { staticClass: "options__split", staticStyle: { display: "block" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.quote.uses_franking_machine,
                  expression: "quote.uses_franking_machine"
                }
              ],
              staticClass: "optionsPanel__content optionsPanel__content",
              staticStyle: {
                display: "flex",
                "text-align": "center",
                width: "100%"
              }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.current_costs.printer.id !== 1,
                      expression: "current_costs.printer.id !== 1"
                    }
                  ],
                  staticStyle: {
                    margin: "0 auto",
                    color: "#0a70e3",
                    "margin-bottom": "20px",
                    "font-weight": "700",
                    "font-size": "1.8rem",
                    "text-transform": "none"
                  }
                },
                [
                  _vm._v("\n              Total current cost of ownership: "),
                  _c("span", {
                    staticClass: "cost",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.makeNumberWithPound(
                          _vm.current_costs.total_cost_per_annum.toFixed(2)
                        )
                      )
                    }
                  }),
                  _vm._v(" ("),
                  _c("span", {
                    staticStyle: {
                      "font-weight": "600",
                      "font-size": "1.8rem"
                    },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.makeNumberWithPound(
                          (_vm.current_costs.total_cost_per_annum / 4).toFixed(
                            2
                          )
                        )
                      )
                    }
                  }),
                  _vm._v(" per quarter)"),
                  _c("span", { staticClass: "cost" }, [_vm._v("^")])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                margin: "0 auto",
                color: "#b50a78",
                "margin-bottom": "20px",
                "font-weight": "700",
                "font-size": "1.8rem",
                "text-transform": "none"
              }
            },
            [
              _vm._v(
                "\n            Based on your requirements, we can provide the following options:\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticStyle: { width: "100%" } }, [
            _c(
              "div",
              { staticClass: "proposed-quote-details-table" },
              _vm._l(_vm.options, function(option, index) {
                return _c(
                  "div",
                  {
                    staticClass: "optionsPanel optionsPanel--withSide",
                    staticStyle: {
                      flex: "1",
                      margin: "5px",
                      border: "1px solid #ccc",
                      "border-radius": "16px",
                      padding: "15px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { "flex-grow": "1", height: "65%" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "row"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { position: "absolute" } },
                              [
                                _c("img", {
                                  staticStyle: {
                                    padding: "0px",
                                    width: "50px",
                                    height: "50px"
                                  },
                                  attrs: {
                                    src:
                                      "/static/styles/mailkit/img/Place" +
                                      (index + 1) +
                                      ".png"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  margin: "0 auto",
                                  position: "relative"
                                }
                              },
                              [
                                _c(
                                  "h5",
                                  {
                                    staticStyle: {
                                      margin: "0 auto",
                                      color: "#0a70e3",
                                      "font-weight": "700",
                                      "font-size": "1.8rem",
                                      padding: "0 25px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          option.years
                                            ? option.years +
                                                " year lease option"
                                            : "Purchase option"
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "optionsPanel__prices",
                            staticStyle: { "font-weight": "700" }
                          },
                          [
                            _vm.quote.uses_franking_machine
                              ? _c("div", [
                                  option.years
                                    ? _c("div", [
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "blue",
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _vm._v("Quarterly investment "),
                                            _c("span", {
                                              staticStyle: {
                                                "font-weight": "700",
                                                "font-size": "1.4rem"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.makeNumberWithPound(
                                                    option.total_investment
                                                  )
                                                )
                                              }
                                            }),
                                            parseFloat(
                                              option.savings_over_term
                                            ) < 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "700",
                                                      "font-size": "1.4rem"
                                                    }
                                                  },
                                                  [_vm._v("*")]
                                                )
                                              : _vm._e(),
                                            parseFloat(
                                              option.savings_over_term
                                            ) >= 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "700",
                                                      "font-size": "1.4rem"
                                                    }
                                                  },
                                                  [_vm._v("^^")]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "red",
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _c("span", [
                                              option.effective_annual_saving > 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "700"
                                                      }
                                                    },
                                                    [
                                                      _vm._v("Annual saving: "),
                                                      _c("span", {
                                                        staticStyle: {
                                                          "font-weight": "700"
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.makeNumberWithPound(
                                                              option.effective_annual_saving
                                                            )
                                                          )
                                                        }
                                                      }),
                                                      _vm._v("**"),
                                                      _c("br")
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              option.savings_over_term > 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "700"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Total savings over term: "
                                                      ),
                                                      _c("span", {
                                                        staticStyle: {
                                                          "font-weight": "700"
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.makeNumberWithPound(
                                                              option.savings_over_term
                                                            )
                                                          )
                                                        }
                                                      }),
                                                      _vm._v("**")
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          ]
                                        )
                                      ])
                                    : _c("div", [
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "blue",
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _vm._v("First year cost "),
                                            _c("span", {
                                              staticStyle: {
                                                "font-weight": "700",
                                                "font-size": "1.4rem"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.makeNumberWithPound(
                                                    option.total_investment
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v("*")
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "blue",
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _vm._v("Year 2 service cost "),
                                            _c("span", {
                                              staticStyle: {
                                                "font-weight": "700",
                                                "font-size": "1.4rem"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.makeNumberWithPound(
                                                    option.total_service_cost
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "red",
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _c("span", [
                                              option.savings_over_term > 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "700"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Savings over 5 years: "
                                                      ),
                                                      _c("span", {
                                                        staticStyle: {
                                                          "font-weight": "700"
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.makeNumberWithPound(
                                                              option.savings_over_term
                                                            )
                                                          )
                                                        }
                                                      }),
                                                      _vm._v("**")
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          ]
                                        )
                                      ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.quote.uses_franking_machine
                              ? _c("div", [
                                  option.years
                                    ? _c("div", [
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "blue",
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _vm._v("Quarterly investment "),
                                            _c("span", {
                                              staticStyle: {
                                                "font-weight": "700",
                                                "font-size": "1.4rem"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.makeNumberWithPound(
                                                    option.total_investment
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v("*")
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "red",
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _c("span", [
                                              option.annual_postage_savings > 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "700"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Annual postage savings: "
                                                      ),
                                                      _c("span", {
                                                        staticStyle: {
                                                          "font-weight": "700"
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.makeNumberWithPound(
                                                              option.annual_postage_savings
                                                            )
                                                          )
                                                        }
                                                      }),
                                                      _vm._v("**"),
                                                      _c("br")
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              option.postage_savings_over_term >
                                              0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "700"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Total postage savings over term: "
                                                      ),
                                                      _c("span", {
                                                        staticStyle: {
                                                          "font-weight": "700"
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.makeNumberWithPound(
                                                              option.postage_savings_over_term
                                                            )
                                                          )
                                                        }
                                                      }),
                                                      _vm._v("**")
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          ]
                                        )
                                      ])
                                    : _c("div", [
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "blue",
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _vm._v("First year cost "),
                                            _c("span", {
                                              staticStyle: {
                                                "font-weight": "700",
                                                "font-size": "1.4rem"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.makeNumberWithPound(
                                                    option.total_investment
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v("*")
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "blue",
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _vm._v("Year 2 cost "),
                                            _c("span", {
                                              staticStyle: {
                                                "font-weight": "700",
                                                "font-size": "1.4rem"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.makeNumberWithPound(
                                                    option.total_service_cost
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "red",
                                            staticStyle: {
                                              "font-weight": "700"
                                            }
                                          },
                                          [
                                            _c("span", [
                                              option.postage_savings_over_term >
                                              0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "700"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Postage savings over 5 years: "
                                                      ),
                                                      _c("span", {
                                                        staticStyle: {
                                                          "font-weight": "700"
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.makeNumberWithPound(
                                                              option.postage_savings_over_term
                                                            )
                                                          )
                                                        }
                                                      }),
                                                      _vm._v("**")
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          ]
                                        )
                                      ])
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-gradient",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            return _vm.progressWithOrder(option.years)
                          }
                        }
                      },
                      [_vm._v("Proceed")]
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                color: "black",
                padding: "10px 0px",
                "text-transform": "none"
              }
            },
            [
              _vm.quote.uses_franking_machine
                ? _c(
                    "b",
                    {
                      staticClass: "red",
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "1.4rem"
                      }
                    },
                    [
                      _vm._v(
                        "\n          ^ Includes rental, service, invoice fees, insurance fees, recrediting fees and consumables where applicable"
                      ),
                      _c("br")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.quote.uses_franking_machine &&
              _vm.postageSavingsOverTermPositive >= 0
                ? _c(
                    "b",
                    {
                      staticClass: "red",
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "1.4rem"
                      }
                    },
                    [
                      _vm._v(
                        "\n          ** Based on the daily volume of letters provided. Assumes all mail processed is letter format (0-100g)."
                      ),
                      _c("br")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.quote.uses_franking_machine &&
              _vm.options[0].savings_over_term > 0
                ? [_vm._m(0)]
                : _vm._e(),
              _vm._v(" "),
              (_vm.quote.uses_franking_machine &&
                _vm.savingsOverTermNegative > 0) ||
              !_vm.quote.uses_franking_machine
                ? [_vm._m(1)]
                : _vm._e(),
              _vm._v(" "),
              _vm.quote.uses_franking_machine && _vm.savingsOverTermPositive > 0
                ? _c(
                    "b",
                    {
                      staticClass: "red",
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "1.4rem"
                      }
                    },
                    [
                      _vm._v(
                        "\n          ** Includes anticipated savings on ink, labels, postage and machine rental/service costs"
                      ),
                      _c("br")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm.quote.uses_franking_machine
                ? _c(
                    "b",
                    {
                      staticClass: "blue",
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "1.4rem"
                      }
                    },
                    [
                      _vm._v(
                        "Please note: Additional costs may apply for delivery, installation and administration. Consumable spend includes estimated ink, labels and recrediting charges"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.quote.uses_franking_machine
                ? _c(
                    "b",
                    {
                      staticClass: "blue",
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "1.4rem"
                      }
                    },
                    [
                      _vm._v(
                        "Please note: Additional costs may apply for delivery, installation and administration."
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "advert-banner-table",
              staticStyle: { display: "flex", width: "100%" }
            },
            [
              _c("div", { staticStyle: { flex: "50%", display: "flex" } }, [
                _c(
                  "div",
                  {
                    staticClass: "optionsPanel",
                    staticStyle: {
                      width: "100%",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("div", { staticClass: "optionsPanel__image" }, [
                      _c("img", {
                        staticClass: "manufacturer_image",
                        class: { "width-250": _vm.model.manufacturer_id === 5 },
                        attrs: {
                          src: _vm.manufacturerImage(_vm.model.manufacturer_id)
                        }
                      })
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { flex: "50%" } }, [
                _vm.videoEmbed
                  ? _c(
                      "div",
                      {
                        staticClass: "optionsPanel",
                        staticStyle: { "border-left": "none" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "optionsPanel__content optionsPanel__content--noPadding"
                          },
                          [
                            _c("h5", [
                              _vm._v(_vm._s(_vm.model.model) + " DEMO VIDEO")
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: { innerHTML: _vm._s(_vm.videoEmbed) }
                            })
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { width: "100%", "padding-left": "0px" } }, [
            _c("table", { staticClass: "featureTable" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", { staticClass: "bg-grey-light" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Printing capabilities\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.model.printing_capabilities) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(4)
                ]),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [
                    _vm._v("\n              Programmable jobs\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.model.programmable_jobs) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(6)
                ]),
                _vm._v(" "),
                _vm._m(7),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light border-t-3" }, [
                  _c("td", [_vm._v("\n              Ink yield\n            ")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.model.ink_yield) +
                        " impressions per ink cartridge\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(8)
                ]),
                _vm._v(" "),
                _vm._m(9),
                _vm._v(" "),
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [
                    _vm._v("\n              Cost per impression\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.makeNumberWithPound(
                            _vm.model.cost_per_impression,
                            4
                          )
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm._m(10)
                ]),
                _vm._v(" "),
                _vm._m(11),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light border-t-3" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Logo return address capacity\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.model.return_address_capacity) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(12)
                ]),
                _vm._v(" "),
                _vm._m(13),
                _vm._v(" "),
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [
                    _vm._v("\n              Interface type\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.model.interface_type) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(14)
                ]),
                _vm._v(" "),
                _vm._m(15),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light border-t-3" }, [
                  _c("td", [
                    _vm._v("\n              Mail feeder\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.model.mail_feeder) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(16)
                ]),
                _vm._v(" "),
                _vm._m(17),
                _vm._v(" "),
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [
                    _vm._v("\n              Label dispenser\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.model.label_dispenser) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(18)
                ]),
                _vm._v(" "),
                _vm._m(19),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light border-t-3" }, [
                  _c("td", [
                    _vm._v("\n              Web based reporting\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.model.web_based_reporting === "yes"
                      ? _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/tick.png")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/cross.png")
                          }
                        })
                  ]),
                  _vm._v(" "),
                  _vm._m(20)
                ]),
                _vm._v(" "),
                _vm._m(21),
                _vm._v(" "),
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [_vm._v("\n              Dimension\n            ")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.model.dimensions) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(22)
                ]),
                _vm._v(" "),
                _vm._m(23),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light border-t-3" }, [
                  _c("td", [
                    _vm._v("\n              Mail mark compliant\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.model.mail_mark_compliant === "yes"
                      ? _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/tick.png")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/cross.png")
                          }
                        })
                  ]),
                  _vm._v(" "),
                  _vm._m(24)
                ]),
                _vm._v(" "),
                _vm._m(25),
                _vm._v(" "),
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Installation and training\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.model.engineer_installation_training === "Included" ||
                    _vm.additionalOptions.engineer_installation_training ===
                      "add"
                      ? _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/tick.png")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.additionalOptions.engineer_installation_training !==
                      "add" &&
                    (_vm.additionalOptions.engineer_installation_training ===
                      false ||
                      _vm.model.engineer_installation_training === null ||
                      _vm.model.engineer_installation_training ===
                        "Not Included (Available at additional cost)")
                      ? _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/cross.png")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.additionalOptions.engineer_installation_training ===
                      null &&
                    _vm.model.engineer_installation_training ===
                      "Not Included (Available at additional cost)"
                      ? _c("span", [
                          _c("br"),
                          _vm._v(
                            "\n                Available at additional cost\n              "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(26)
                ]),
                _vm._v(" "),
                _vm._m(27),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light border-t-3" }, [
                  _c("td", [
                    _vm._v("\n              Scale capacity\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.formatScale(_vm.model, _vm.additionalOptions)
                        ) +
                        " KG\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(28)
                ]),
                _vm._v(" "),
                _vm._m(29),
                _vm._v(" "),
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Custom Logo/Return Address Included with New Machine\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.additionalOptions.logo_and_return_address === "add" ||
                    (_vm.model.return_address_included_with_machine ===
                      "Included" &&
                      _vm.additionalOptions.logo_and_return_address === null)
                      ? _c("span", [
                          _c("img", {
                            attrs: {
                              src: require("./../../../static/styles/mailkit/img/tick.png")
                            }
                          })
                        ])
                      : _c("span", [
                          _c("img", {
                            attrs: {
                              src: require("./../../../static/styles/mailkit/img/cross.png")
                            }
                          }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm.additionalOptions.logo_and_return_address === null
                            ? _c("span", [
                                _vm._v("Available at additional cost")
                              ])
                            : _vm._e()
                        ])
                  ]),
                  _vm._v(" "),
                  _vm._m(30)
                ]),
                _vm._v(" "),
                _vm._m(31),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light border-t-3" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Business mail advanced\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.additionalOptions.business_mail_advanced === "add"
                      ? _c("span", [
                          _c("img", {
                            attrs: {
                              src: require("./../../../static/styles/mailkit/img/tick.png")
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.model.business_mail_advanced &&
                      !_vm.model.business_mail_advanced.includes("included")) ||
                    _vm.additionalOptions.business_mail_advanced === false
                      ? _c("span", [
                          _c("img", {
                            attrs: {
                              src: require("./../../../static/styles/mailkit/img/cross.png")
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.model.business_mail_advanced &&
                    _vm.model.business_mail_advanced.includes("included") &&
                    _vm.additionalOptions.business_mail_advanced === null
                      ? _c("span", [
                          _c("img", {
                            attrs: {
                              src: require("./../../../static/styles/mailkit/img/cross.png")
                            }
                          }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [_vm._v("Available at additional cost")])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(32)
                ]),
                _vm._v(" "),
                _vm._m(33),
                _vm._v(" "),
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Connectivity kit options\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.additionalOptions.connectivity === null
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.model.connectivity) +
                              "\n              "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.additionalOptions.connectivity !== null
                      ? _c(
                          "span",
                          { staticStyle: { "text-transform": "uppercase" } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.additionalOptions.connectivity) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(34)
                ]),
                _vm._v(" "),
                _vm._m(35),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light border-t-3" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Inbound courier parcel tracing\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.model.integrated_internal_mail_tracking_app &&
                    _vm.model.integrated_internal_mail_tracking_app.includes(
                      "Included"
                    ) &&
                    (_vm.additionalOptions
                      .inbound_courier_parcel_tracking_cost === null ||
                      _vm.additionalOptions
                        .inbound_courier_parcel_tracking_cost === "add")
                      ? _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/tick.png")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/cross.png")
                          }
                        }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.model.integrated_internal_mail_tracking_app
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(36)
                ]),
                _vm._v(" "),
                _vm._m(37),
                _vm._v(" "),
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Outbound shipping application\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.additionalOptions.outbound_shipping_application === null
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.model.shipping_application) +
                              "\n                "
                          ),
                          _vm.model.shipping_application ===
                          "Yes Single User Included (Optional Kit available includes 30kg Scale and Shipping Label Printer)"
                            ? _c("span", [
                                _vm._v(
                                  "\n                 Available at additional cost\n                "
                                )
                              ])
                            : _vm._e()
                        ])
                      : _c("span", [
                          _vm.additionalOptions
                            .outbound_shipping_application === "add"
                            ? _c("span", [
                                _c("img", {
                                  attrs: {
                                    src: require("./../../../static/styles/mailkit/img/tick.png")
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions
                            .outbound_shipping_application === false
                            ? _c("span", [
                                _c("img", {
                                  attrs: {
                                    src: require("./../../../static/styles/mailkit/img/cross.png")
                                  }
                                })
                              ])
                            : _vm._e()
                        ])
                  ]),
                  _vm._v(" "),
                  _vm._m(38)
                ]),
                _vm._v(" "),
                _vm._m(39),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light border-t-3" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Departmental accounting\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.getModelDepAccounting(_vm.model)) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(40)
                ]),
                _vm._v(" "),
                _vm._m(41),
                _vm._v(" "),
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Differential weighting\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.additionalOptions.differential_weighting === "add"
                      ? _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/tick.png")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.model.differential_weighting ||
                    _vm.model.differential_weighting === "No" ||
                    _vm.additionalOptions.differential_weighting === false
                      ? _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/cross.png")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.model.differential_weighting === "Yes" ||
                      _vm.model.differential_weighting === "Optional") &&
                    _vm.additionalOptions.differential_weighting === null
                      ? _c("span", [
                          _vm._v(
                            "\n                Available at additional cost\n              "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(42)
                ]),
                _vm._v(" "),
                _vm._m(43),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light border-t-3" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Service / maintenance offering\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.service_upgrade === "standard"
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.model.service_name) +
                              "\n              "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.service_upgrade === "enhanced"
                      ? _c("span", [
                          _vm.model.manufacturer_id === 4
                            ? _c("span", [_vm._v("swapit+")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.model.manufacturer_id === 3
                            ? _c("span", [_vm._v("total care")])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.service_upgrade === null
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.model.service_name) +
                              "\n              "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("td")
                ]),
                _vm._v(" "),
                _vm._m(44)
              ]),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", { staticClass: "bg-grey-light" }, [
                  _c("td", [
                    _vm._v("\n              First step\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.model.first_step) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td")
                ]),
                _vm._v(" "),
                _vm._m(45),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light" }, [
                  _c("td", [
                    _vm._v("\n              Second step\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.model.second_step) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td")
                ]),
                _vm._v(" "),
                _vm._m(46),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light" }, [
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.service_upgrade ||
                            _vm.new_costs
                              .postage_recredit_costs_updated_to_total_care
                            ? "ENHANCED"
                            : null
                        ) +
                        " Third step\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.service_upgrade ||
                            _vm.new_costs
                              .postage_recredit_costs_updated_to_total_care
                            ? _vm.model.enhanced_third_step
                            : _vm.model.third_step
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td")
                ]),
                _vm._v(" "),
                _vm._m(47),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light" }, [
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.service_upgrade ||
                            _vm.new_costs
                              .postage_recredit_costs_updated_to_total_care
                            ? "ENHANCED"
                            : null
                        ) +
                        " Targeted service level\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.service_upgrade ||
                            _vm.new_costs
                              .postage_recredit_costs_updated_to_total_care
                            ? _vm.model.sla_enhanced
                            : _vm.model.sla_standard
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td")
                ]),
                _vm._v(" "),
                _vm._m(48),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light" }, [
                  _c("td", [_vm._v("\n              All parts\n            ")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.model.all_parts === null
                      ? _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/cross.png")
                          }
                        })
                      : _c("span", [
                          _c("img", {
                            attrs: {
                              src: require("./../../../static/styles/mailkit/img/tick.png")
                            }
                          }),
                          _vm._v(" Yes\n              ")
                        ])
                  ]),
                  _vm._v(" "),
                  _c("td")
                ]),
                _vm._v(" "),
                _vm._m(49),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light" }, [
                  _c("td", [
                    _vm._v("\n              All labour\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.model.all_labour === null
                      ? _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/cross.png")
                          }
                        })
                      : _c("span", [
                          _c("img", {
                            attrs: {
                              src: require("./../../../static/styles/mailkit/img/tick.png")
                            }
                          }),
                          _vm._v(" Yes\n              ")
                        ])
                  ]),
                  _vm._v(" "),
                  _c("td")
                ]),
                _vm._v(" "),
                _vm._m(50),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light" }, [
                  _c("td", [
                    _vm._v("\n              Wear & tear\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.model.wear_and_tear === null
                      ? _c("img", {
                          attrs: {
                            src: require("./../../../static/styles/mailkit/img/cross.png")
                          }
                        })
                      : _c("span", [
                          _c("img", {
                            attrs: {
                              src: require("./../../../static/styles/mailkit/img/tick.png")
                            }
                          }),
                          _vm._v(
                            " Yes - Excluding Consumable Parts\n              "
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _c("td")
                ]),
                _vm._v(" "),
                _vm._m(51),
                _vm._v(" "),
                _c("tr", { staticClass: "bg-grey-light" }, [
                  _c("td", [
                    _vm._v(
                      "\n              Royal mail rate updates\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.model.tariff_rate_updates_included_per_annum
                        ) +
                        " Per annum\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td")
                ]),
                _vm._v(" "),
                _vm._m(52)
              ]),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", { staticClass: "border-t-3" }, [
                  _c("td", [
                    _vm._v("\n              Postage account type\n            ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm.additionalOptions.postage_payment
                      ? _c(
                          "span",
                          { staticStyle: { "text-transform": "uppercase" } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.additionalOptions.postage_payment) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm._m(53)
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "nopadding", attrs: { colspan: "3" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "infoContent",
                          staticStyle: { display: "none" },
                          attrs: { "data-ft": "POSTAGE ACCOUNT TYPE" }
                        },
                        [
                          _vm.additionalOptions.postage_payment === "arrears"
                            ? _c("article", [
                                _vm._m(54),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "This service is only available through Pitney Bowes and Quadient (Neopost) at this time. This service\n                    allows businesses to top up franking machines, pulling funds from an agreed credit limit. Rather\n                    than an invoice for every postage top up/refill a monthly statement covering all transactions\n                    during that monthly billing period is instead sent. This service typically carries higher\n                    recrediting fees but reduces the number of invoices to one consolidated monthly statement and\n                    means your business doesn't have funds tied up and sitting in a holding account. Pitney Bowes\n                    payment in arrears service is called Purchase Power. Quadient (Neopost) is called Neofunds. "
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.additionalOptions.postage_payment === "advanced"
                            ? _c("article", [
                                _vm._m(55),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "The payment in advanced services are available from all manufacturers and require your business\n                    to prepay into a deposit/holding account. When your franking machine is refilled/topped up funds\n                    will be drawn down from your account. For each top up/refill transaction your business will be\n                    invoiced for each transaction, plus any associated reset/recrediting charges. On payment of this\n                    invoice your holding/deposit account is replenished to the agreed balance ensuring you have\n                    suitable funds available for when you next need to top up."
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.additionalOptions.postage_payment === "advanced"
                  ? _c(
                      "tr",
                      {
                        staticStyle: { background: "white", "border-top": "0" }
                      },
                      [
                        _c("td", [
                          _vm._v("\n              Free resets\n            ")
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "span",
                            { staticStyle: { "text-transform": "uppercase" } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.model.postage_deposit_account || 0
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("td")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.additionalOptions.postage_payment === "advanced"
                  ? _c("tr", [_vm._m(56)])
                  : _vm._e(),
                _vm._v(" "),
                _vm.additionalOptions.postage_payment === "advanced"
                  ? _c(
                      "tr",
                      {
                        staticStyle: { background: "white", "border-top": "0" }
                      },
                      [
                        _c("td", [
                          _vm._v(
                            "\n              Cost per additional reset\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", {
                            staticStyle: { "text-transform": "uppercase" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.makeNumberWithPound(
                                  _vm.model
                                    .postage_deposit_account_cost_per_resets ||
                                    0
                                )
                              )
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.additionalOptions.postage_payment === "advanced"
                  ? _c("tr", [_vm._m(57)])
                  : _vm._e(),
                _vm._v(" "),
                _vm.additionalOptions.postage_payment === "arrears"
                  ? _c(
                      "tr",
                      {
                        staticStyle: {
                          background: "#f4f4f4",
                          "border-top": "0"
                        }
                      },
                      [
                        _c("td", [
                          _vm._v(
                            "\n                  Your Monthly Top Up Cost*\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                  £" +
                              _vm._s(
                                (
                                  _vm.new_costs.postage_recredit_costs / 12
                                ).toFixed(2) || 0
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                  *Based on monthly postage spend\n              "
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.additionalOptions.postage_payment === "arrears"
                  ? _c("tr", [_vm._m(58)])
                  : _vm._e(),
                _vm._v(" "),
                _vm.additionalOptions.postage_payment === "arrears"
                  ? _c(
                      "tr",
                      {
                        staticStyle: {
                          background: "#f4f4f4",
                          "border-top": "0"
                        }
                      },
                      [
                        _c("td", [
                          _vm._v(
                            "\n                  Top up value range\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                  Cost per top up\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.additionalOptions.postage_payment === "arrears"
                  ? _c("tr", [_vm._m(59)])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.additionalOptions.postage_payment === "arrears" &&
              _vm.model.manufacturer.name === "Quadient (Neopost)"
                ? _c("tbody", [
                    _c("tr", [
                      _c("td", [_vm._v("£0 - £800")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "£" +
                            _vm._s(
                              _vm.model
                                .monthly_top_up_option_1_unlimited_transactions_monthly_fee
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("£801 - £2,000")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "£" +
                            _vm._s(
                              _vm.model
                                .monthly_top_up_option_2_unlimited_transactions_monthly_fee
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("£2001 - £4,000")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "£" +
                            _vm._s(
                              _vm.model
                                .monthly_top_up_option_3_unlimited_transactions_monthly_fee
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("£4001 - £10,000")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "£" +
                            _vm._s(
                              _vm.model
                                .monthly_top_up_option_4_unlimited_transactions_monthly_fee
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _vm.quote.postage_spend_custom > 10000
                      ? _c("tr", [
                          _c("td", [_vm._v("£10,001+")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.model.totalcare_transaction_fees_option_5
                              ) + "%"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td")
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.additionalOptions.postage_payment === "arrears" &&
              _vm.model.manufacturer.name === "PITNEY BOWES"
                ? _c("tbody", [
                    _c("tr", [
                      _c("td", [_vm._v("£0 - £100")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "£" +
                            _vm._s(
                              _vm.model.monthly_top_up_option_1_transaction_fee
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("£101 - £300")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "£" +
                            _vm._s(
                              _vm.model.monthly_top_up_option_2_transaction_fee
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("£301 - £1,300")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "£" +
                            _vm._s(
                              _vm.model.monthly_top_up_option_3_transaction_fee
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("£1,300+")]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.model.monthly_top_up_option_4_transaction_fee
                          ) + "%"
                        )
                      ]),
                      _vm._v(" "),
                      _c("td")
                    ])
                  ])
                : _vm._e()
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "b",
      {
        staticClass: "blue",
        staticStyle: { "font-weight": "bold", "font-size": "1.4rem" }
      },
      [
        _vm._v(
          "^^ Includes, rental/purchase, service, consumables and recredit fee costs"
        ),
        _c("br")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "b",
      {
        staticClass: "blue",
        staticStyle: { "font-weight": "bold", "font-size": "1.4rem" }
      },
      [_vm._v("* Includes both rental/purchase and service costs."), _c("br")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          background: "linear-gradient(45deg,#0a70e3,#f81e8c)",
          color: "#fff",
          "font-size": "44px",
          padding: "30px"
        }
      },
      [
        _vm._v("\n        Free ink and labels up to the value of £100"),
        _c("br"),
        _vm._v("with every qualifying order*"),
        _c("br"),
        _c(
          "span",
          {
            staticStyle: {
              color: "#fff",
              display: "block",
              "margin-top": "20px",
              "font-size": "20px"
            }
          },
          [
            _vm._v("*Terms and conditions may apply. Click "),
            _c(
              "a",
              {
                staticStyle: { color: "#fff", "font-size": "inherit" },
                attrs: {
                  href:
                    "https://themailingexpert.com/terms-and-conditions/#promotion-terms-conditions"
                }
              },
              [_vm._v("here")]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", [_vm._v("\n            Feature\n          ")]),
      _vm._v(" "),
      _c("th", [_vm._v("\n            Specification\n          ")]),
      _vm._v(" "),
      _c("th", [_vm._v("\n            Info and upgrade options\n          ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "PRINTING CAPABILITIES" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "PROGRAMMABLE JOBS" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "INK YIELD" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "COST PER IMPRESSION" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "LOGO RETURN ADDRESS CAPACITY" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "INTERFACE TYPE" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "MAIL FEEDER" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "LABEL DISPENSER" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "WEB BASED REPORTING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "DIMENSIONS" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "MAIL MARK COMPLIANT" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "INSTALLATION AND TRAINING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "SCALE CAPACITY" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: {
            "data-ft": "CUSTOM LOGO/RETURN ADDRESS INCLUDED WITH NEW MACHINE"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "BUSINESS MAIL ADVANCED" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "CONNECTIVITY KIT OPTIONS" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "INBOUND COURIER PARCEL TRACING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "OUTBOUND SHIPPING APPLICATION" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "DEPARTMENTAL ACCOUNTING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "DIFFERENTIAL WEIGHING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "bg-grey-light" }, [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "SERVICE / MAINTENANCE OFFERING" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "bg-grey-light" }, [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "FIRST STEP" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "bg-grey-light" }, [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "SECOND STEP" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "bg-grey-light" }, [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "THIRD STEP" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "bg-grey-light" }, [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "TARGETED SERVICE LEVEL" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "bg-grey-light" }, [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "ALL PARTS" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "bg-grey-light" }, [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "ALL LABOUR" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "bg-grey-light" }, [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "WEAR & TEAR" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
        _c("div", {
          staticClass: "infoContent",
          staticStyle: { display: "none" },
          attrs: { "data-ft": "ROYAL MAIL RATE UPDATES" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { staticClass: "underline infoToggle" }, [
        _vm._v("More information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [_c("strong", [_vm._v("PAYMENT IN ARREARS:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [_c("strong", [_vm._v("PAYMENT IN ADVANCED:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
      _c("div", {
        staticClass: "infoContent",
        staticStyle: { display: "none" },
        attrs: { "data-ft": "POSTAGE ACCOUNT TYPE" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
      _c("div", {
        staticClass: "infoContent",
        staticStyle: { display: "none" },
        attrs: { "data-ft": "POSTAGE ACCOUNT TYPE" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
      _c("div", {
        staticClass: "infoContent",
        staticStyle: { display: "none" },
        attrs: { "data-ft": "POSTAGE ACCOUNT TYPE" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "nopadding", attrs: { colspan: "3" } }, [
      _c("div", {
        staticClass: "infoContent",
        staticStyle: { display: "none" },
        attrs: { "data-ft": "POSTAGE ACCOUNT TYPE" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8462dc14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8462dc14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Results/MoreInfo.vue
// module id = null
// module chunks = 